import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import styles from './index.module.css';

const SevenReserveAuctionPage = () => {
  const { find, meta } = usePageContent('seven-reserve-auction');
  const seo = meta?.seo;
  useTitle(seo?.title || 'An Iconic First Release');
  useMeta(seo);
  const c = find('richText') || {};

  return (
    <div id="content">
      <div className="page-header">
        <div className="container">
          <h1 className="page-header__title">{c.pageTitle || 'An Iconic First Release'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        <div className={`rich-text ${styles.wrapper}`} dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }} />
      </div>
    </div>
  );
};

export default SevenReserveAuctionPage;
